export enum QuoteExpirationTimeOption {
  SEVEN_DAYS = 'seven_days',
  FOURTEEN_DAYS = 'fourteen_days',
  THIRTY_DAYS = 'thirty_days',
  SIXTY_DAYS = 'sixty_days',
}
